import IntegrationResultList from './IntegrationResultList'
import IntegrationResultShow from './IntegrationResultShow'

export default {
  IntegrationResultList,
  IntegrationResultShow
}
